export const CnhIconComponent = ({
  size = 32,
  fillColor = '#FFFFFF00',
  strokeColor = '#454545',
  style
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <rect width="32" height="32" rx="16" fill={fillColor} />
    <path d="M14 19.3333C14 20.0697 13.403 20.6667 12.6667 20.6667C11.9303 20.6667 11.3333 20.0697 11.3333 19.3333M14 19.3333C14 18.597 13.403 18 12.6667 18C11.9303 18 11.3333 18.597 11.3333 19.3333M14 19.3333H18M11.3333 19.3333H10V15.3333M20.6667 19.3333C20.6667 20.0697 20.0697 20.6667 19.3333 20.6667C18.597 20.6667 18 20.0697 18 19.3333M20.6667 19.3333C20.6667 18.597 20.0697 18 19.3333 18C18.597 18 18 18.597 18 19.3333M20.6667 19.3333H22V16.6667C22 16.313 21.8595 15.9739 21.6095 15.7239C21.3594 15.4738 21.0203 15.3333 20.6667 15.3333H20M10 15.3333L11.3333 12H17.3333L20 15.3333M10 15.3333H20M16 15.3333V12" stroke={strokeColor} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
);
